<template>
	<div class="application--wrap centered-content">
		<v-toolbar transparent :flat="true" app class="white--text">
			<v-btn icon @click="gotoWelcome">
				<v-icon color="white">arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>Registreren</v-toolbar-title>
			<v-btn icon></v-btn>
		</v-toolbar>

		<v-content>
			<v-container>
				<form class="text-xs-center" @submit.prevent="submit">

					<validation-observer ref="validationObserver">
						<validation-provider name="E-mail" rules="required|email|unique:email" v-slot="{ errors }" slim>
							<v-text-field
								v-model="email"
								type="email"
								label="E-mail *"
								:error-messages="errors[0]"
								required box dark
								class="my-2"
							></v-text-field>
						</validation-provider>

						<validation-provider vid="password" name="Wachtwoord" rules="required" v-slot="{ errors }">
							<v-text-field
								v-model="password"
								type="password"
								label="Wachtwoord *"
								:error-messages="errors[0]"
								required box dark hide-details
							></v-text-field>
						</validation-provider>

						<validation-provider vid="password_confirmation" name="Wachtwoord" rules="required|confirmed:password" v-slot="{ errors }">
							<v-text-field
								v-model="password_confirmation"
								type="password"
								label="Wachtwoord bevestiging *"
								:error-messages="errors[0]"
								required box dark
								class="mb-4"
							></v-text-field>
						</validation-provider>
					</validation-observer>

					<v-btn
						type="submit"
						block large depressed
						color="primary"
						class="white--text mb-2"
					>
						Registreren
					</v-btn>
				</form>

			</v-container>
		</v-content>
	</div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import { mapFields } from 'vuex-map-fields';

  export default {
    components: { ValidationProvider, ValidationObserver },
    computed: {
      ...mapFields('registerUser', [
        'user.email',
        'user.password',
      ])
    },
    data() {
      return {
        password_confirmation: '',
      };
    },
    methods: {
      gotoWelcome() {
        this.$router.push('/');
      },
      submit() {
        this.$refs.validationObserver.validate()
          .then(valid => {
            if (valid) return this.$router.push('/register/name');
            window.scrollTo(0, 0);
          })
          .catch(({ errors }) => {
            window.scrollTo(0, 0);
          });
      }
    },
	created(){
      this.password = '';
	}
  };
</script>


